const CompanyModel = {
  id: null,
  name: '',
  legal_name: '',
  federal_register: '',
  legal_representative: ''
};

export default CompanyModel;
